import React from "react"
import "./css/Header.css"
import "./css/Catalogue.css"
import img1109 from "../assets/1109-cat.jpg"
import img0904 from "../assets/0904-cat.jpg"
import img0767 from "../assets/0767-cat.jpg"
import img0778 from "../assets/0778-cat.jpg"
import img101 from "../assets/101-cat.jpg"
import img102 from "../assets/102-cat.jpg"

const Catalogue = () => {
  const products = [
    {
      name: "Seeds",
      text: "Our seeds database has almost 200 species varieties of mostly indigenous seeds found in Kenya & other parts of the world. This is made possible by our extensive network of seed collectors across the country. Our seeds are usually fresh, and have very high viability and germination rates.",
      images: [img0904, img1109],
      features: ["200+ Species Varieties", "Indigenous Seeds", "High Viability Rates", "Fresh Seeds"]
    },
    {
      name: "Tree Seedlings",
      text: "Our large and expansive Tree Nursery has a large variety of trees and for different uses including medicinal, fruit, fodder, shade, and ornamental. We have well trained staff who take great care in ensuring seedlings are of good quality. Our company has succeeded admirably in holding true to the vision of providing seedlings for reforestation to perpetuate renewable resources. Our seedlings for export are of various sizes, ranging from 30cm to 150cm.",
      images: [img0778, img0767],
      features: ["Multiple Uses", "Quality Assured", "30-150cm Sizes", "Export Ready"]
    },
    {
      name: "Mature Trees",
      text: "We have medium size to big indigenous trees such as Acacia & Adansonia (Baobab) for sale to landscapers, commercial developers or the private individuals seeking instant appeal and impact. Our Trees are shipped in Open Top Sea Containers & we obtain & abide by all the legal requirements & documentation.",
      images: [img101, img102],
      features: ["Indigenous Species", "Instant Impact", "Legal Compliance", "Global Shipping"]
    }
  ]

  return (
    <div className="catalogue-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <div className="header-content">
            <h1 className="page-title">Our Products Catalogue</h1>
            <p className="page-subtitle">
              Pioneer in Kenya's tree export market with 200+ species varieties and expert cultivation
            </p>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="intro-section">
        <div className="container">
          <div className="intro-content">
            <h2 className="section-title">Export Excellence</h2>
            <div className="title-underline"></div>
            <p className="intro-text">
              Jambo Tree Kenya is a pioneer in the trees export market in Kenya. After many years of experience & research, our trees are grown in a soilless growing medium, making them suitable for export to many markets. We strictly adhere to the{" "}
              <a href="https://www.iucnredlist.org/about/regional" target="_blank" rel="noopener noreferrer" className="external-link">
                IUCN Red List
              </a>
              , and international regulations on combating bio-piracy. We arrange the necessary phytosanitary certificates & licences according to market requirements. Shipment are done via air or sea-freight.
            </p>
            
            <div className="intro-highlights">
              <div className="highlight-item">
                <h4>🌍 Global Compliance</h4>
                <p>IUCN Red List adherence and anti-bio-piracy measures</p>
              </div>
              <div className="highlight-item">
                <h4>📋 Legal Documentation</h4>
                <p>Phytosanitary certificates & market-specific licenses</p>
              </div>
              <div className="highlight-item">
                <h4>🚢 Flexible Shipping</h4>
                <p>Air and sea-freight options available</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="products-section">
        <div className="container">
          {products.map((product, index) => (
            <div key={index} className="product-section" id={product.name}>
              <div className="product-content">
                <div className="product-info">
                  <h2 className="product-title">{product.name}</h2>
                  <div className="product-underline"></div>
                  <p className="product-description">{product.text}</p>
                  
                  <div className="product-features">
                    <h4>Key Features:</h4>
                    <div className="features-grid">
                      {product.features.map((feature, featureIndex) => (
                        <div key={featureIndex} className="feature-item">
                          <span className="feature-icon">✓</span>
                          <span className="feature-text">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                
                <div className="product-images">
                  <div className="images-grid">
                    {product.images.map((image, imageIndex) => (
                      <div key={imageIndex} className="image-container">
                        <img src={image} alt={`${product.name} ${imageIndex + 1}`} className="product-image" />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Download Section */}
      <section className="download-section">
        <div className="container">
          <div className="download-content">
            <div className="download-card">
              <h2>📋 Download Our Catalogue</h2>
              <p>
                If you are interested in ordering our seeds, seedlings or trees, download our complete catalogue with pricing information.
              </p>
              <a href="prices.xlsx" download="prices.xlsx" className="btn btn-primary download-btn">
                <span>📥</span>
                Products List
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="catalogue-cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Place Your Order?</h2>
            <p>Contact our team to discuss your specific requirements and get a customized quote.</p>
            <div className="cta-buttons">
              <a href="/work-with-us" className="btn btn-primary">Request Quote</a>
              <a href="/contact" className="btn btn-outline">Contact Us</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Catalogue